// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wc_a bhl_b","TwoDimsListFeature__item":"wc_b bhl_wb","TwoDimsListFeature__item__text":"wc_c bhl_vr"};